import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbsenceEmployeeFile } from '@qaroni-app/absences/types/absence-employee-file';
import { FileViewerDialogComponent } from '@qaroni-shared/components/dialogs/file-viewer-dialog/file-viewer-dialog.component';
import { FileViewerDialogData } from '@qaroni-shared/types/file-viewer-dialog-data';
import { QaroniDialogConfig } from '@qaroni-core/types/dialogs/qaroni-dialog-config';

@Component({
  selector: 'qaroni-permits-employees-list-table-files-preview',
  templateUrl: './permits-employees-list-table-files-preview.component.html',
  styleUrl: './permits-employees-list-table-files-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PermitsEmployeesListTableFilesPreviewComponent {
  readonly files = input<AbsenceEmployeeFile[]>([]);
  public isOpen = false;

  private dialog = inject(MatDialog);

  get tooltipText(): string {
    return this.files()?.length ? $localize`Ver adjuntos` : '';
  }

  get ngClassColor(): string {
    return this.files()?.length ? 'text-primary-50' : 'text-slate-500';
  }

  get icon(): string {
    return this.files()?.length ? 'attach_file' : 'attach_file_off';
  }

  public onClick() {
    this.isOpen = !this.isOpen;
  }

  public onFilePreview(file: AbsenceEmployeeFile) {
    if (!file) {
      return;
    }

    const data = {
      fileName: file.file,
      fileUrl: file.fileUrl,
      useViewer: false,
    };

    const dialogConfig = new QaroniDialogConfig<FileViewerDialogData>();
    dialogConfig.data = data;
    dialogConfig.width = '1024px';
    dialogConfig.height = '730px';

    this.dialog.open<FileViewerDialogComponent, FileViewerDialogData, boolean>(
      FileViewerDialogComponent,
      dialogConfig
    );
    this.isOpen = false;
  }
}
